import { render } from "./LabEquipmentPage.vue?vue&type=template&id=316ae55a"
import script from "./LabEquipmentPage.vue?vue&type=script&lang=js"
export * from "./LabEquipmentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__